import { DataSource, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutOutstandingLoadTenderTotal extends Layout {
    labelOverallCount: Label;
    labelTotal: Label;
    panelTotal: Panel;
    sourceLtxOutstandingCounts: DataSource;
}
